<template>
  <div class="loading-page">
    <loading
      color="#007bff"
      :width="100"
      :height="100"
      :active.sync="isPageLoading"
    />
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    name: 'page-loading',
    components: {
      Loading: () => import('vue-loading-overlay')
    },
    computed: {
      ...mapState({
        isPageLoading: rootState => rootState.isPageLoading
      })
    },
    mounted() {
      this.$nextTick(async () => {
        await import('vue-loading-overlay/dist/vue-loading.css');
      })
    },
    methods: {
      ...mapMutations({
        showLoading: 'showPageLoading',
        hideLoading: 'hidePageLoading'
      }),
      start() {
        this.showLoading()
      },
      finish() {
        this.hideLoading()
      }
    }
  }
</script>
